import { generate } from '@ant-design/colors'
import { GrnData } from 'Store/grn/types'

const randomNum = () => Math.floor(Math.random() * (235 - 52 + 1) + 52)

export const randomRGB = () => `rgb(${randomNum()}, ${randomNum()}, ${randomNum()})`

export const generateColor = (color: string) => {
  return generate(color)
}

export const genColor = (index: number) => {
  const color20 = [
    '#f37720',
    '#FBCEB1',
    '#B07A6D',
    '#988F87',
    '#8EC3B9',
    '#F5F1E6',
    '#423268',
    '#4A548F',
    '#7E7FB2',
    '#8891B2',
    '#A5866C',
    '#210805',
    '#BCAA6C',
    '#989A72',
    '#ABCCD0',
    '#629AA2',
    '#33443D',
    '#94896A',
    '#C2A689',
  ]
  return color20[index] || randomRGB()
}

let lastId = 0

export const newID = (prefix = 'id') => {
  lastId++
  return `${prefix}${lastId}`
}

const isIngroup = (
  group: {
    purchasing_no: string
    grn: GrnData[]
  }[],
  purchasing_no: string,
) => {
  const result = group.find(item => item.purchasing_no === purchasing_no)
  return result ? true : false
}

export const groupGrnByPurchase = (datas: GrnData[]) => {
  let group = [] as {
    purchasing_no: string
    grn: GrnData[]
  }[]

  datas &&
    datas.forEach(element => {
      const purchasing_no = element?.purchasing?.purchasing_no || ''
      if (!isIngroup(group, purchasing_no)) {
        group.push({
          purchasing_no: purchasing_no,
          grn: [element],
        })
      } else {
        group = group.map(item => {
          if (item.purchasing_no === purchasing_no) {
            item.grn.push(element)
          }
          return item
        })
      }
    })
  return group
}
